import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useMutation } from '@tanstack/react-query'
import { HealthClaimFormInput } from '../types'

const createHealthClaim = async (data: HealthClaimFormInput) => {
  const response = await httpClientPrivate.post(`${config.restUrl}/v1/backoffice/e-claim`, data)

  return response.data
}

const useCreateHealthClaim = () => {
  const mutation = useMutation({
    mutationKey: ['useCreateHealthClaim'],
    mutationFn: async (data: HealthClaimFormInput) => createHealthClaim(data),
  })

  return mutation
}

export { useCreateHealthClaim }
